import $ from 'jquery';
// import select2 from 'select2/dist/js/select2.full.min.js';
// import DataTable from 'datatables.net-bs5'
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import jqueryI18next from 'jquery-i18next';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';

// import 'datatables.net-bs5';
// import 'datatables.net-buttons-bs5';
// import 'datatables.net-select';
// import 'datatables.net-buttons/js/buttons.html5';
// import 'datatables.net-buttons/js/buttons.print';
// import 'pdfmake';
// import 'pdfmake/build/vfs_fonts';

// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';

window.$ = window.jQuery = $;
// window.pdfMake = pdfMake;

// $.fn.select2 = select2;

// Store language preference using cookie
export function get_cookie(name) {
  const value = document.cookie
    .split("; ")
    .find(row => row.startsWith(name + "="));
  return value ? value.split("=")[1] : null;
}

export function set_cookie(name, value) {
  document.cookie = `${name}=${value}; path=/`;
}

export function change_lang(lang) {
  set_cookie("lang", lang);
}

let sys_lang = navigator.language.toLowerCase().includes('zh') ? 'zh' : 'en';
const saved_lang = get_cookie("lang") || sys_lang;

// Switch Language
window.i18nReady = new Promise((resolve, reject) => {
  i18n
    .use(HttpBackend)
    .init({
      lng: saved_lang,
      fallbackLng: false,
      debug: false,
      backend: {
        loadPath: '../locales/{{lng}}/translation.json'
      }
    }, function(err, t) {
      if (err) {
        reject(err);
        return;
      }

      jqueryI18next.init(i18n, $);

      $('body').localize();
      $('#languageSwitcher').val(saved_lang);

      $('#languageSwitcher').on('change', function () {
        const selectedLang = $(this).val();

        change_lang(selectedLang);
        window.location.reload();
      });

      resolve(); 
    });
});
